import React from "react";
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showOrderType } from '../../redux/actions/display';
import CircularProgress from '@material-ui/core/CircularProgress';

const Detail = (props) => {
  const { t } = useTranslation();
  let classIcon = "box-open";
  let type = "open orders";
  let selected = "";
  let isUrl = false;
  // let url = '';
  let isCredit = false;

  if(props.show === props.id){
    selected = " selected";
  }
  if(props.id === 0){
    classIcon = "users";
    type = t('detail.TotalOrders');
  }
  else if(props.id === 1){
    classIcon = "box-open";
    type = t('detail.TotalProducts');
  }
  else if(props.id === 2){
    // url = "/dyno-green.png";
    type = t('detail.WonderlandPoints');
    isUrl = true;
  }
  // else if(props.id === 3){
  //   classIcon = "shopping-cart";
  //   type = "closed orders";
  // }
  else if(props.id === 3){
    classIcon = "wallet";
    type = "apm credits";
    isCredit = true
  }

  return (
    <div className="detail__wrapper col-lg-3 col-md-6 col-12">
      {/* <div className={"detail detail-"+props.id+selected} onClick={() => props.dispatch(showOrderType(props.id))}>
        <h1>{props.data}<span>{type}</span></h1>
        <i className={"fas fa-" + classIcon}></i>
      </div> */}
      {
        isCredit ? (
          <div className={"detail detail-scroll"}>
            {
              props.credits.initCredits ? props.credits.credits && props.credits.credits.length > 0 ? (
                <div className="apm-credit">
                  <h1 className="apm-credit-title">{ t('detail.APMCredits') }</h1>
                  {
                    props.credits.credits.map(item => {
                      return (
                        <h1 className="h1-credit" key={item.countryCode}>
                          <div className="credit">
                            <div className="credit-flex left">
                              <div className="credit-country-code">{item.countryCode}</div>
                              <div className="credit-exp-date-label">{ t('detail.ExpireOn') }</div>
                            </div>
                            <div className="credit-flex right">
                              <div className="credit-credits">{item.Credits}</div>
                              <div className="credit-exp-date">{item.exp}</div>
                            </div>
                          </div>
                        </h1>
                      )
                    })
                  }
                </div>
              ) : (
                <h1 className="h1-no-credit">{ t('detail.NoAPMCredits') }</h1>
              ) : (
                <div className="credit-loading">
                  <CircularProgress />
                  <h1 className="h1-loading-text">{ t('detail.CreditsLoading') }</h1>
                </div>
              )
            }
          </div>
        ) : (
          <div className={"detail detail-"+ props.id + selected} onClick={() => props.dispatch(showOrderType(props.id))}>
            <h1>{props.data}<span>{type}</span></h1>
            {isUrl ?
              <img src='/dyno-green.png' alt='wonderland logo' className="wonderland-icon" />
              :
              <i className={"fas fa-" + classIcon}></i>
            }
          </div>
        )
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    show: state.display.show,
    credits: state.credits
  }
}

export default connect(
  mapStateToProps
)(Detail);



// WEBPACK FOOTER //
// ./src/js/components/Detail.jsx